import "@/composables/useNotification";
import { uuidPattern } from "../../lib/raft_generic_helper";

const EditChemicalType = () =>
  import("../../components/chemdb_type/EditChemicalType.vue");
const EditChemicalRegulations = () =>
  import("../../components/chemdb_type/EditChemicalRegulations.vue");
const NotFound = () => import("../../components/NotFound.vue");

// Allow a UUID or numeric node ID.
const nodePattern = uuidPattern + "|[1-9][0-9]*";

const routes = [
  {
    path: "/raft/chemdb/chemical/:chemical(" + nodePattern + ")/edit",
    props: true,
    component: EditChemicalType,
  },
  {
    path: "/raft/chemdb/chemical/:chemical(" + nodePattern + ")/regulations",
    props: true,
    component: EditChemicalRegulations,
  },
  {
    path: "/raft/chemdb/chemical/js/404",
    component: NotFound,
    name: "chemdbNotFound",
  },
];

const globalComponents = {};

export {
  routes as chemdbTypeRoutes,
  globalComponents as chemdbTypeGlobalComponents,
};
